import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-wavecamp",
  "use": "icon-wavecamp-usage",
  "viewBox": "0 0 2432 104",
  "content": "<symbol xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 2432 104\" id=\"icon-wavecamp\">\r\n  <g transform=\"matrix(1 0 0 1 619 -674 )\">\r\n    <path d=\"M 0 104  L 2431 104  L 2431 66.0689655172414  C 2431 66.0689655172414  2252.37931034483 0.551724137931046  2104.10344827586 0.551724137931046  C 1955.8275862069 0.551724137931046  1749.14778325123 49.0738916256158  1573.28571428571 48.1428571428572  C 1397.4236453202 47.2118226600986  1255.97432134996 -0.768892149669909  955.827586206897 0.551724137931046  C 655.68085106383 1.872340425532  638.586206896552 68  511 68  C 383.413793103448 68  238.586206896552 0.551724137931046  148.931034482758 0.551724137931046  C 59.2758620689657 0.551724137931046  0.655172413793025 68  0.655172413793025 68  L 0 104  Z \" fill-rule=\"nonzero\" fill=\"#ffffff\" stroke=\"none\" transform=\"matrix(1 0 0 1 -619 674 )\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/wavecamp.svg
// module id = A/fb
// module chunks = 0